import { Download, Shield, Smartphone, Users } from 'lucide-react'
import React from 'react'

const DownloadSection = () => {
    return (
        <section id="download" className="py-20 bg-gradient-to-r from-[#002047] to-blue-800 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl lg:text-4xl font-bold mb-4">
                        Download Smart Dairy Today
                    </h2>
                    <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                        Available on Google Play Store. Get started with your 7-day free trial and transform your dairy business.
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="space-y-8">
                        <div className="flex items-center space-x-4">
                            <div className="bg-white/20 p-3 rounded-lg">
                                <Download className="h-8 w-8" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold">Easy Installation</h3>
                                <p className="text-blue-100">Download from Play Store and set up in minutes</p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4">
                            <div className="bg-white/20 p-3 rounded-lg">
                                <Shield className="h-8 w-8" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold">Free Trial</h3>
                                <p className="text-blue-100">7-day free trial with full access to all features</p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4">
                            <div className="bg-white/20 p-3 rounded-lg">
                                <Users className="h-8 w-8" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold">Expert Support</h3>
                                <p className="text-blue-100">Get help from our dairy industry experts</p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8">
                            <img src='./logo.png' className="h-32 w-32 mx-auto text-white mb-4" />
                            <h3 className="text-2xl font-bold mb-2">Smart Dairy App</h3>
                            <p className="text-blue-100">Your complete dairy management solution</p>
                        </div>

                        <a
                            href="https://play.google.com/store/apps/details?id=com.thesmartdairyapp"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center space-x-3 bg-black text-white px-8 py-4 rounded-[12px] font-semibold hover:bg-gray-800 transition-colors"
                        >
                            <div className="flex space-x-2 items-center gap-2">
                                <div className="w-10 aspect-square  rounded-full flex items-center justify-center">
                                    <img src='./playStore.png' className='w-full' />
                                </div>
                                <div className="text-left">
                                    <div className="text-xs">GET IT ON</div>
                                    <div className="text-lg font-bold">Google Play</div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default DownloadSection
